<template>
  <div class="box1">
    <div class="back" @click="goBack">
      <img src="@/assets/home/back.png" alt="" />
    </div>
    <!-- 底部小模型图片 -->
    <div class="bottImg">
      <div
        v-for="item in imgData"
        :class="item.className"
        :key="item.bs"
        @click="$router.push(`/${item.path}`)"
      >
        <img :src="`img/${item.bs}.png`" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "box1",
  components: {},
  data() {
    //这里存放数据
    return {
      imgData: [
        {
          bs: "1_1_1",
          className: "left",
          path: "box1a",
        },
        {
          bs: "1_1_2",
          className: "bottom",
          path: "box1b",
        },
        {
          bs: "1_1_3",
          className: "right",
          path: "box1c",
        },
        {
          bs: "1_1_4",
          className: "left",
          path: "box1d",
        },
        {
          bs: "1_1_5",
          className: "bottom",
          path: "box1e",
        },
        {
          bs: "1_1_6",
          className: "right",
          path: "box1f",
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    goBack() {
      this.imgData.forEach((v) => {
        if (v.className === "leftShow") v.className = "left";
        else if (v.className === "rightShow") v.className = "right";
        else if (v.className === "bottomShow") v.className = "bottom";
      });
      this.$router.push("/Info1");
    },
    modelShow() {
      let dom = document.querySelector("#WebGL-output");
      let lodDom = document.querySelector("#Stats-output");

      const scene = new THREE.Scene();
      // 2、声明一个混合器变量
      let mixer = null;
      //相机
      let camera = new THREE.PerspectiveCamera(
        8,
        window.innerWidth / window.innerHeight,
        0.1,
        10000
      );
      //设置相机坐标
      camera.position.set(0, window.innerHeight, 500);
      //渲染器
      let renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      //设置渲染器的颜色和大小
      renderer.setClearColor(0xeeeeee, 0.0);
      renderer.setSize(window.innerWidth, window.innerHeight);
      //将renderer（渲染器）的dom元素（renderer.domElement）添加到我们的HTML文档中。
      //这就是渲染器用来显示场景给我们看的<canvas>元素
      dom.appendChild(renderer.domElement);

      //鼠标控制旋转
      let controls = new THREE.OrbitControls(camera, renderer.domElement);
      //设置是否可以缩放,默认值为true
      // controls.enableZoom = false;
      //设置鼠标交互,设置为false之后，不能移动位置，不能旋转物体,默认为true
      // controls.enableRotate = false;
      //设置光源
      let light = new THREE.DirectionalLight(0xffffff, 0.5);
      light.position.setScalar(100);
      scene.add(light);
      scene.add(new THREE.AmbientLight(0xffffff, 0.5));
      // 3、定义fbx模型加载器
      let loader = new THREE.FBXLoader();

      // 4、进行加载
      loader.load("data/box1/open.fbx", function (mesh) {
        scene.add(mesh);
        lodDom.style.display = "none";
        mixer = new THREE.AnimationMixer(mesh); //mesh作为参数创建一个混合器，解析播放mesh及其子对象包含的动画数据
        // console.log(mesh.animations);  //可以查看动画数据
        let action = mixer.clipAction(mesh.animations[0]); //获得剪辑对象clip
        action.timeScale = 1; //调节播放速度，默认为1
        action.loop = THREE.LoopOnce; //不循环播放
        action.clampWhenFinished = true; //暂停在最后一帧的播放状态
        action.play(); //播放动画
        // 5、创建一个时钟对象
        let clock = new THREE.Clock();
        function render() {
          renderer.render(scene, camera);
          requestAnimationFrame(render); //请求再次执行渲染函数render，渲染下一帧
          let time = clock.getDelta(); //获得两帧的时间间隔
          if (mixer !== null) {
            mixer.update(time); //更新混合器相关的时间
          }
        }
        render();
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.modelShow();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.imgData.forEach((v) => {
          if (v.className === "left") v.className = "leftShow";
          else if (v.className === "right") v.className = "rightShow";
          else if (v.className === "bottom") v.className = "bottomShow";
        });
      }, 500);
    });
  }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.box1 {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #073e5c;
  .back {
    z-index: 10;
    position: absolute;
    top: 20px;
    left: 20px;
    width: 40px;
    height: 23px;
    pointer-events: auto;
    touch-action: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  // #Stats-output {
  //   z-index: 20;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   & > img {
  //     width: 50px;
  //   }
  // }
  // #WebGL-output {
  //   position: absolute;
  //   top: 0px;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  // }
  .bottImg {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: absolute;
    z-index: 10;
    bottom: 2px;
    left: 0;
    width: 100%;
    height: 20%;
    & > div {
      opacity: 0;
      position: relative;
      transition: all 0.5s;
      width: 33%;
      height: 48%;
      text-align: center;
      & > img {
        height: 100%;
      }
      .active {
        border: 2px solid blue;
        pointer-events: none;
      }
    }
    .left {
      left: -200px;
    }
    .right {
      right: -200px;
    }
    .bottom {
      bottom: -200px;
    }
    .leftShow {
      opacity: 1;
      left: 0px;
    }
    .rightShow {
      opacity: 1;
      right: 0px;
    }
    .bottomShow {
      opacity: 1;
      bottom: 0px;
    }
  }
  .modeSmBox {
    position: absolute;
    z-index: 11;
    top: 0;
    left: 0;
    width: 100%;
    height: 80%;
    background-color: #07405f;
    .back {
      z-index: 10;
      position: absolute;
      top: 20px;
      left: 20px;
      width: 40px;
      height: 23px;
      pointer-events: auto;
      touch-action: auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>